'use strict';

var cookiesApp = function () {
  var cookiesBlock = void 0;
  var _showCookiesAdvice = function _showCookiesAdvice() {
    cookiesBlock.classList.add('active');
  };

  var _buttonAcceptListen = function _buttonAcceptListen() {
    var acceptButton = document.querySelector('.js-accept-cookies');
    acceptButton.addEventListener('click', function () {
      cookiesBlock.classList.remove('active');
      sessionStorage.localCookies = true;
    });
  };
  var _init = function _init() {
    // cookiesBlock = document.querySelector('.js-cookies-block')
    // if (!sessionStorage.localCookies) {
    //   _showCookiesAdvice()
    //   _buttonAcceptListen()
    // }
  };
  return {
    init: _init
  };
}();